(function ($) {
  var metrics = null;

  function requiredExists() {
    return (
      $('#topSv').length &&
      $('#top-sv-content').length &&
      $('#sv-content').length &&
      $('#p-topSv__height01').length &&
      $('#p-topSv__height02').length &&
      $('#p-topSv__height03').length &&
      $('#p-topSv__height04').length
    );
  }

  function measure() {
    if (!requiredExists()) return null;

    var $wrapper = $('#top-sv-content');
    var $content = $('#sv-content');
    var deviceWidth = $(window).width();
    var contentWidth = $content.innerWidth();

    // WPと同様、初期配置で測定
    $wrapper.css({
      top: '',
      position: ''
    });

    if (deviceWidth < 900) {
      contentWidth = deviceWidth * (360 / 390);
    } else if (contentWidth > 774) {
      contentWidth = 774;
    } else {
      contentWidth = deviceWidth - 248;
    }

    return {
      topSvTop: $('#topSv').offset().top,
      topSvTop02: $('#p-topSv__height02').offset().top,
      topSvBottom02: $('#p-topSv__height02').offset().top + $('#p-topSv__height02').innerHeight(),
      topSvTop03: $('#p-topSv__height03').offset().top,
      topSvBottom03: $('#p-topSv__height03').offset().top + $('#p-topSv__height03').innerHeight(),
      topSvTop04: $('#p-topSv__height04').offset().top,
      topSvBottom04: $('#p-topSv__height04').offset().top + $('#p-topSv__height04').innerHeight(),
      topSvTopContent: $wrapper.offset().top,
      contentWidth: contentWidth
    };
  }

  function apply() {
    if (!requiredExists()) return;
    if (!metrics) {
      metrics = measure();
      if (!metrics) return;
    }

    var $wrapper = $('#top-sv-content');
    var $content = $('#sv-content');
    var topScrollTop = $(window).scrollTop();
    var deviceWidthTop = $(window).width();

    var topSvContentDistance = metrics.topSvTop - metrics.topSvTopContent;
    if (topSvContentDistance === 0) topSvContentDistance = 1;
    var topSvContentGap = metrics.topSvTop - topScrollTop;
    var svContentGapRate = (topSvContentDistance - topSvContentGap) / topSvContentDistance;
    var svContentRadiusPc = 21 - (21 * svContentGapRate);
    var svContentRadiusSp = 12 - (12 * svContentGapRate);
    var baseWidth = deviceWidthTop < 900 ? deviceWidthTop * (360 / 390) : metrics.contentWidth;
    var svContentWidth = deviceWidthTop - ((deviceWidthTop - baseWidth) - ((deviceWidthTop - baseWidth) * svContentGapRate));

    if (topScrollTop < metrics.topSvTopContent) {
      $('#sv-subHead').removeClass('js-hidden');
    } else {
      $('#sv-subHead').addClass('js-hidden');
    }

    if (deviceWidthTop < 900) {
      if (topSvContentGap < topSvContentDistance && 0 < topSvContentGap) {
        $content.css({
          width: svContentWidth + 'px',
          borderRadius: svContentRadiusSp + 'px',
          maxWidth: '100%',
          height: '100vh'
        });
      }
      if (topScrollTop < metrics.topSvTopContent) {
        $content.css({
          maxWidth: '92.3%',
          height: 'calc(100vh - 289px)'
        });
      }
    } else {
      if (topSvContentGap < topSvContentDistance && 0 < topSvContentGap) {
        $content.css({
          width: svContentWidth + 'px',
          borderRadius: svContentRadiusPc + 'px',
          maxWidth: svContentWidth + 'px',
          height: '100vh'
        });
      }
      if (topScrollTop < metrics.topSvTopContent) {
        $content.css({
          maxWidth: '774px',
          height: 'calc(100vh - 270px)'
        });
      }
    }

    if (topScrollTop >= metrics.topSvTopContent) {
      $wrapper.css({
        top: '0',
        position: 'fixed'
      });
    } else {
      $wrapper.css({
        top: 'calc(312px - 100vh)',
        position: 'absolute'
      });
    }

    $wrapper.toggleClass('js-active', topScrollTop >= metrics.topSvTop);
    $wrapper.toggleClass('js-concept02', topScrollTop >= metrics.topSvTop02 && topScrollTop < metrics.topSvBottom02);
    $wrapper.toggleClass('js-concept03', topScrollTop >= metrics.topSvTop03 && topScrollTop < metrics.topSvBottom03);
    $wrapper.toggleClass('js-concept04', topScrollTop >= metrics.topSvTop04 && topScrollTop < metrics.topSvBottom04);
  }

  function boot() {
    if (!requiredExists()) return;
    metrics = measure();
    apply();

    setTimeout(function () {
      metrics = measure();
      apply();
    }, 300);

    setTimeout(function () {
      metrics = measure();
      apply();
    }, 1000);
  }

  var scrollTicking = false;
  function onScrollRaf() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      apply();
      scrollTicking = false;
    });
  }

  $(window).off('scroll.e8topsv resize.e8topsv orientationchange.e8topsv load.e8topsv');
  $(window).on('scroll.e8topsv', onScrollRaf);
  $(window).on('resize.e8topsv orientationchange.e8topsv', function () {
    metrics = measure();
    apply();
  });
  $(window).on('load.e8topsv', boot);

  $(function () {
    boot();
  });

  document.addEventListener('shopify:section:load', function () {
    boot();
  });
})(jQuery);